<template>
  <div class="container">
    <v-btn small fab color="teal" router to="/profile">
      <v-icon color="white">cancel</v-icon>
    </v-btn>
    <v-btn small fab color="teal" router to="/upload">
      <v-icon color="white">photo_camera</v-icon>
    </v-btn>
    <v-card>
      <v-card-text>
        <v-form class="px-3" ref="form">
          <h3
            color="white"
            class="py-0 px-2 teal white--text"
          >Organisation Profile and Contact Details</h3>
          <v-text-field
            v-model="name"
            label="Name of Organisation"
            prepend-icon="business"
            :rules="inputRules"
          ></v-text-field>
          <v-textarea
            solo
            v-model="about"
            label="Write a brief of description of the main of the organisation and Areas of focus"
            prepend-icon="border_color"
            :rules="inputRules"
          ></v-textarea>
          <v-text-field
            v-model="website"
            label="Official Website"
            prepend-icon="language"
            :rules="inputRules"
          ></v-text-field>
          <h3 class="py-0 px-2 teal white--text">Primary Contact Details</h3>
          <v-text-field
            v-model="contact"
            label="Name of primary Contact Person"
            prepend-icon="contacts"
            :rules="inputRules"
          ></v-text-field>
          <v-text-field
            v-model="email"
            label="Work Email of primary Contact Person"
            prepend-icon="contact_mail"
            :rules="inputRules"
          ></v-text-field>
          <v-text-field
            v-model="phone"
            label="Mobile Number of primary Contact Person"
            prepend-icon="contact_phone"
            :rules="inputRules"
          ></v-text-field>
          <h3 class="py-0 px-2 teal white--text">Alternative Contact Details</h3>
          <v-text-field
            v-model="contact1"
            label="Full names of Secondary Contact"
            prepend-icon="contacts"
            :rules="inputRules"
          ></v-text-field>
          <v-text-field
            v-model="email1"
            label="Email of Secondary Contact Person"
            prepend-icon="contact_mail"
            :rules="inputRules"
          ></v-text-field>
          <v-text-field
            v-model="phone1"
            label="Mobile Number of Secondary Contact Person"
            prepend-icon="contact_phone"
            :rules="inputRules"
          ></v-text-field>

          <v-spacer></v-spacer>

          <v-btn flat @click="updateProfile" class="py-0 px-2 teal white--text">Update Profile</v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>
    
<script>
import { db, auth, functions, auth2 } from "@/fb";
import router from "../router.js";

export default {
  data() {
    return {
      userid: "",
      name: "",
      about: "",
      website: "",
      contact: "",
      email: "",
      phone: "",
      contact1: "",
      email1: "",
      phone1: "",
      userdata: [],
      info: "",
      drawer: false,
      menu: false,
      admin: false,
      inputRules: [
        v => !!v || "This field is required",
        v => v.length >= 5 || "Minimum length is 3 characters"
      ],
      passRules: [
        v => !!v || "This field is required",
        v => v.length >= 8 || "Minimum length is 8 characters"
      ],
      loading: false,
      indialog: false,
      loggedIn: false,
      snackbar: false,
      outdialog: false
    };
  },
  methods: {
    updateProfile() {
      this.userid = auth.currentUser.uid;
      db.collection("members")
        .doc(auth.currentUser.uid)
        .update({
          website: this.website,
          name: this.name,
          about: this.about,
          contactname: this.contact,
          contactemail: this.email,
          contactphone: this.phone,
          contactname1: this.contact1,
          contactemail1: this.email1,
          contactphone1: this.phone1,
          photourl: auth.currentUser.uid + ".png"
        })
        .then(function() {
          router.push({ path: "profile" });
          console.log("Document successfully updated!");
        });
    }
  },
  created() {
    if (auth.currentUser == null) {
      this.$router.push({ name: "home" });
    }
    db.collection("members")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          if (doc.id == auth.currentUser.uid) {
            (this.name = doc.data().name),
              (this.about = doc.data().about),
              (this.email = doc.data().contactemail),
              (this.email1 = doc.data().contactemail1),
              (this.phone1 = doc.data().contactphone1),
              (this.phone = doc.data().contactphone),
              (this.contact = doc.data().contactname),
              (this.contact1 = doc.data().contactname1),
              (this.photourl = doc.data().photourl),
              (this.website = doc.data().website);
          }
        });
      });
  }
};
</script>
